// import DummyText from "./utils/DummyText";
import Navigation from "../components/Navigation";

import BsAccordion from "../components/BsAccordion";
import Lenis from "lenis";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import SliderModule from "../components/Slider";
import SectionModule from "../components/SectionModule";

// Import sharer.js - note: this automatically attaches to DOM
import "sharer.js";

gsap.registerPlugin(ScrollTrigger);

export default class Common {
    constructor() {
        window.addEventListener("resize", () => this.resize());
    }

    init() {
        this.updateVhCssVar();
        this.initLenis();
        this.initNavigation();
        this.initLightbox();
        this.initLightbox2();
        this.initBsAccordion();
        this.initSlider();
        this.initSectionModules();
        this.handleShare()
        this.debugPage()
        this.debugPage2()
    }
    updateVhCssVar() {
        // const header = document.querySelector('header')
        const footer = document.querySelector('footer')
        // document.body.style.setProperty("--header-height", `${header.offsetHeight}px`);
        document.body.style.setProperty("--ft-h", `${footer.offsetHeight}px`);
        document.body.style.setProperty("--ft-h-lg", `${footer.offsetHeight}px`);
    }
    initLenis() {
        // Initialize Lenis
        const lenis = new Lenis({
        duration: 1.4,
        autoRaf: true,
        direction: "vertical",
        smooth: true,
        smoothTouch: false,
        mouseMultiplier: 1,
        // easing: (t) => (t === 1 ? 1 : 1 - Math.sin((t * Math.PI) / 2)),
        });

        // Listen for the scroll event and log the event data
        // lenis.on("scroll", (e) => {
        // });

        // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
        // This ensures Lenis's smooth scroll animation updates on each GSAP tick
        gsap.ticker.add((time) => {
            lenis.raf(time * 1000); // Convert time from seconds to milliseconds
        });

        // Disable lag smoothing in GSAP to prevent any delay in scroll animations
        gsap.ticker.lagSmoothing(0);

        // Use requestAnimationFrame to continuously update the scroll
        // function raf(time) {
        //     lenis.raf(time);
        //     requestAnimationFrame(raf);
        // }

        // requestAnimationFrame(raf);
    }

    initNavigation() {
        let navDOM = document.querySelector("nav");
        let partNav = new Navigation(navDOM);
        // partNav.openSearchBox();
        partNav.menuControl();
        partNav.searchBoxControl();
        partNav.setHideOnScroll();
    }

    initLightbox() {
        let lightBox = document.querySelector("#lightbox");
        let triggerBtn = document.querySelector("[js-lb-tigger]");
        let closeBtns = document.querySelectorAll(".close-btn");

        triggerBtn.addEventListener("click", function (e) {
        e.preventDefault();
        lightBox.classList.add("opened");
        closeBtns.forEach((btn) => {
            btn.addEventListener("click", function (e) {
            e.preventDefault();
            lightBox.classList.remove("opened");
            });
        });
        });
    }

    initLightbox2() {
        let lightBox = document.querySelector("#lightbox-wexin");
        let triggerBtn = document.querySelector("[js-lb-ws-tigger]");
        let closeBtns = document.querySelectorAll(".close-btn");

        triggerBtn.addEventListener("click", function (e) {
        e.preventDefault();
        lightBox.classList.add("opened");
        closeBtns.forEach((btn) => {
            btn.addEventListener("click", function (e) {
            e.preventDefault();
            lightBox.classList.remove("opened");
            });
        });
        });
    }
    initBsAccordion() {
        const cvAccordion = document.querySelector("#accordion-prgm");
        if (cvAccordion) {
        this.accd = new BsAccordion(cvAccordion);
        }
    }

    scrollFadeIn() {
        //fade in batch - from bottom
        const fadeinBatch = document.querySelectorAll("[js-scroll_fadein='batch']");

        if (fadeinBatch) {
        gsap.set(fadeinBatch, { opacity: 0, y: 40 })
        ScrollTrigger.batch("[js-scroll_fadein='batch']", {
            start: "top 90%",
            invalidateOnRefresh: true,
            // markers: true,
            onEnter: (elements, triggers) => {
            gsap.to(elements, { opacity: 1, y: 0, stagger: 0.10 });
            // console.log(elements.length, "elements entered");
            },
            onLeaveBack: (elements, triggers) => {
            //   gsap.to(elements, { opacity: 0, y: 40, stagger: 0.15 });
            // console.log(elements.length, "elements leave back");
            },
        });
        }
        //fade in from bottom
        const fadeinBottom = gsap.utils.toArray("[js-scroll_fadein='bottom']");
        if (fadeinBottom) {
        fadeinBottom.forEach((el, i) => {
            ScrollTrigger.create({
            trigger: el,
            start: "top 90%",
            invalidateOnRefresh: true,
            markers: true,
            onEnter: () => {
                gsap.to(el, { opacity: 1, y: 0 });
                el.classList.add("fade-in");
                // console.log(el, "elements entered");
            },
            onLeaveBack: () => {
                gsap.to(el, { opacity: 0, y: 40 });
                el.classList.remove("fade-in");
                // console.log(el, "elements leave back");
            },
            });
        });
        }
        //fade in from left
        const fadeinLeft = gsap.utils.toArray("[js-scroll_fadein='left']");
        if (fadeinLeft) {
        fadeinLeft.forEach((el, i) => {
            ScrollTrigger.create({
            trigger: el,
            start: "top 90%",
            invalidateOnRefresh: true,
            // markers: true,
            onEnter: () => {
                gsap.to(el, { opacity: 1, x: 0 });
                el.classList.add("fade-in");
                // console.log(el, "elements entered");
            },
            onLeaveBack: () => {
                gsap.to(el, { opacity: 0, x: -40 });
                el.classList.remove("fade-in");
                // console.log(el, "elements leave back");
            },
            });
        });
        }
        //fade in from right
        const fadeinRight = gsap.utils.toArray("[js-scroll_fadein='right']");
        if (fadeinRight) {
        fadeinRight.forEach((el, i) => {
            ScrollTrigger.create({
            trigger: el,
            start: "top 90%",
            invalidateOnRefresh: true,
            // markers: true,
            onEnter: () => {
                // console.log(el, "elements entered");
                gsap.to(el, { opacity: 1, x: 0 });
                el.classList.add("fade-in");
                
            },
            onLeaveBack: () => {
                // console.log(el, "elements leave back");
                gsap.to(el, { opacity: 0, x: 40 });
                el.classList.remove("fade-in");
                
            },
            });
        });
        }

        ScrollTrigger.refresh();
    }

    initSlider() {
        const sliderWrapper = document.querySelectorAll(".slider-section");

        sliderWrapper.forEach((slider) => {
            new SliderModule(slider);
        });

        // if (sliderWrapper) {
        //   this.sl = new SliderModule(sliderWrapper);
        // }
    }

    initSectionModules() {
        const sectionModules = document.querySelectorAll(".section-modules section");
        sectionModules.forEach((section) => {
            new SectionModule(section);
        });
    }

    handleShare() {
        document.querySelectorAll('.www-share a').forEach((item, i) => {
            // Set the current URL as the share URL for each share button
            const url = window.location.href;
            item.setAttribute('data-url', url);
            
            // sharer.js automatically binds to elements with data-sharer attributes
            // The click event is handled by the library, so we don't need to add another event listener
            // Just ensure the data-url and data-title attributes are set correctly
        });
        
        // Force window.Sharer to re-init (ensure all elements are properly bound)
        if (window.Sharer && typeof window.Sharer.init === 'function') {
            window.Sharer.init();
        }
    }

    debugPage() {
        const debug = document.querySelector("#page-showroom .grid-content, #page-partnership-details .grid-content, #page-404 .grid-content");
        if (debug) {
            const el_banner = document.querySelector(".m-top-banner .img-wrap");
            ScrollTrigger.create({
                trigger: debug,
                start: "top 0%",
                invalidateOnRefresh: true,
                // markers: true,
                onEnter: () => {
                    el_banner.classList.add("d-none");
                    // console.log(debug, "elements entered");
                },
                onLeaveBack: () => {
                    el_banner.classList.remove("d-none");
                    // console.log(debug, "elements leave back");
                },
            });
        }
    }
    debugPage2() {
        const debug = document.querySelector("#page-partnership .br-page--content");
        if (debug) {
            const el_banner = document.querySelector(".br-page--banner");
            ScrollTrigger.create({
                trigger: debug,
                start: "top 0%",
                invalidateOnRefresh: true,
                // markers: true,
                onEnter: () => {
                    el_banner.classList.add("d-none");
                    // console.log(debug, "elements entered");
                },
                onLeaveBack: () => {
                    el_banner.classList.remove("d-none");
                    // console.log(debug, "elements leave back");
                },
            });
        }
    }
    resize() {
        this.updateVhCssVar()
    }
}
